import { useEffect, useState } from "react";
import useErrorHandler from "./FormErrorHandler";
import {
  TextInput,
  FormInputRow,
  FormSection,
  TextField,
  PhoneNumberInput,
  AddressInput,
} from "../FormInput/FormInput";

const InjuredPersonsInfo = ({
  id,
  index,
  data,
  setinjuredPersonsInfo,
  canRemove = true,
}) => {
  const [isFocused, setIsFocused] = useState(false)
  const { error, addError, clearError, hasError, focusedField } = useErrorHandler();

  const validate = async (formData) => {
    clearError();

    if (!formData.FirstName) {
      addError({ FirstName: "First name is required" }, false);
    }

    if (!formData.LastName) {
      addError({ LastName: "Last name is required" }, false);
    }

    if (formData.ZipCode && (isNaN(parseInt(formData.ZipCode)) || formData.ZipCode.toString().length != 5)){
      addError({ ZipCode: "Enter a 5 digit zip code" }, false);
    }

    if (!formData.description) {
      addError({ description: "Please describe the injury" }, false);
    }

    return !hasError();
  };

  useEffect(() => {
    if(focusedField && isFocused){
      const fieldToFocus = index + focusedField
      const element = document.getElementById(fieldToFocus);
      if (element) {
        element.focus();
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [focusedField, isFocused, error])

  const [info, setInfo] = useState({ ...data, validate });

  const updateinjuredPersonsInfo = (fieldName, value) => {
    setInfo((prevInfo) => {
      const temp = { ...prevInfo, [fieldName]: value };
      setinjuredPersonsInfo((prevPersons) =>
        prevPersons.map((person) =>
          person.id === prevInfo.id ? temp : person
        )
      );
      return temp;
    });
  };

  useEffect(() => {
    updateinjuredPersonsInfo("validate", validate);
    updateinjuredPersonsInfo("setIsFocused", setIsFocused);
  }, []);

  return (
    <FormSection
      header={
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
          id={id}
        >
          <div>Injured Person {index + 1}</div>
          {canRemove ? (
            <RemoveButton
              id={id}
              setinjuredPersonsInfo={setinjuredPersonsInfo}
            />
          ) : (
            <></>
          )}
        </div>
      }
    >
      <FormInputRow header="Full Name*">
        <TextInput
          id={index}
          fieldName="FirstName"
          value={info.FirstName}
          handleInputChange={updateinjuredPersonsInfo}
          placeholder="First Name"
          error={error}
        />
        <TextInput
          id={index}
          fieldName="LastName"
          value={info.LastName}
          handleInputChange={updateinjuredPersonsInfo}
          placeholder="Last Name"
          error={error}
        />
      </FormInputRow>

      <FormInputRow header="Phone Number">
        <PhoneNumberInput
          id={index}
          fieldName="PhoneNumber"
          value={info.PhoneNumber}
          handleInputChange={updateinjuredPersonsInfo}
        />
      </FormInputRow>

      <FormInputRow header="Home Address">
        <AddressInput
          id={index}
          addressData={info}
          handleInputChange={updateinjuredPersonsInfo}
          error={error}
        />
      </FormInputRow>
      <FormInputRow header="Please describe any injuries this person sustained in the loss:*">
        <TextField
          id={index}
          fieldName="description"
          value={info.description}
          handleInputChange={updateinjuredPersonsInfo}
          error={error}
        />
      </FormInputRow>
    </FormSection>
  );
};

const RemoveButton = ({ id, setinjuredPersonsInfo }) => {
  const removeInjuredPerson = () => {
    setinjuredPersonsInfo((prev) =>
      prev.filter((person) => {
        return person.id !== id;
      })
    );
  };

  return (
    <button
      className="btn btn-primary btn-sm m-1 px-4 fw-bold"
      style={{ borderRadius: "20px" }}
      onClick={() => removeInjuredPerson()}
    >
      Remove
    </button>
  );
};

export default InjuredPersonsInfo;
